<span *ngIf="value; else emptyValue">{{ value | phoneNumber }}</span>
<ng-template #emptyValue>
  <span *ngIf="emptyValueDisplay">{{ emptyValueDisplay }}</span>
</ng-template>
